import { Component, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "@app/core/services/ats/authentication.service";
import { UIUtil } from "@app/core/utils/ui.util";
import { Authetication, session_keys } from "@app/core";
import { UserDetails } from "@app/core/models/admin.model";
import { JSEncrypt } from "jsencrypt";
import { NzMessageService } from "ng-zorro-antd";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private message: NzMessageService,
  ) {
    this.activeModule = router.url;
    this.userDetails = UIUtil.getPrivateData(session_keys.private_key);
  }
  activeModule: string;
  userDetails: Authetication;
  // password = '';
  // cPassword: any = '';
  // oldPassword: any = '';
  // isResetPwd = true;
  // incorrectPwd: Boolean = false;
  // inconsistentPwd: Boolean = false;
  // samePassword: Boolean = false;

  oldPassword: any = null;
  newPassword: any = null;
  confirmPassword: any = null;

  newPwdVisible: boolean = false;
  oldPwdVisible: boolean = false;
  confirmPwdVisible: boolean = false;

  popupModelResetPwd = {
    isVisible: false,
    loading: false,
    messageText: "",
  };
  isStrongPwd = true;

  encrypt = new JSEncrypt();
  decrypt = new JSEncrypt();
  encryptedData: string;

  publicKey = `
  -----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqBQi7hZ1rU0f14jnzeAH
fyY5ElLQKJ9uCikWHmrBNF0jwplmO9Upb0nrkcBZiPHCTpBlPVytbH44v6cGw4Pr
PtyrTsI/PfHlYtmB/rTZ9zV19y+ZCrNM1faLvDqDiFP0B9Jffd9uTwlihmusDWgI
+DiV/uPbKey7YXI0+ZdWV8IN8bTPyO4aXVRg8gSiZZTqlN59Z++tP8kjR9bZCqpk
dN7UA3ULnE9tMqUnd7wA0RX/a9hVxPkMnQceGZk1hH82BtP8ONKnwjR42PYbvKEY
wQzaGOHHISwvoDB5QsqivGb48ivF04aZlBGVgPlJIsHf+ihkLwQcux3hddCUKSWT
7QIDAQAB
-----END PUBLIC KEY-----
  `;

  openDashboard() {
    if (this.activeModule.indexOf("ats") >= 0) {
      this.router.navigate(["ats/dashboard"]);
    } else if (this.activeModule.indexOf("campus") >= 0) {
      this.router.navigate(["campus/dashboard"]);
    }
  }

  ngOnInit() {}

  logout() {
    this.authenticationService.logout().subscribe((response) => {
      localStorage.clear();
      this.router.navigate(["./login"]);
    });
  }

  resetPasswordPopUp() {
    this.popupModelResetPwd.isVisible = true;
    // this.isResetPwd = true;
  }

  pwdValidationError: any = null;
  checkPwdValidation(event) {
    this.pwdValidationError = null;
    let pwd = event.target.value;
    const strongPwdRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/;

    if (pwd.length < 10) {
      this.pwdValidationError = "Password must be at least 10 characters long";
      return false;
    } else if (!strongPwdRegex.test(pwd)) {
      this.pwdValidationError =
        "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character";
      return false;
    } else if (this.hasRepeatedCharacters(pwd.toLowerCase())) {
      this.pwdValidationError =
        "Password must not contain a character that repeats more than twice consecutively";
      return false;
    } else if (pwd.toLowerCase().startsWith("federal")) {
      this.pwdValidationError = "Password must not start with 'federal'";
      return false;
    } else if (this.hasSequentialChars(pwd)) {
      this.pwdValidationError =
        "Password must not contain sequential characters (e.g., abc, 123)";
      return false;
    } else if (pwd.toLowerCase() == this.userDetails.email.toLowerCase()) {
      this.pwdValidationError =
        "Password must not be your registered email address'";
      return false;
    } else {
      this.pwdValidationError = null;
    }
    this.checkConfirmPwdValidation();
  }

  confirmValidationError: any = null;
  checkConfirmPwdValidation() {
    this.confirmValidationError = null;
    if (this.newPassword !== this.confirmPassword) {
      this.confirmValidationError =
        "Passwords do not match. Please ensure both entries are identical.";
      return false;
    } else {
      this.confirmValidationError = null;
    }
  }

  hasRepeatedCharacters(password: string): boolean {
    return /(.)\1{2,}/.test(password);
  }

  hasSequentialChars(str: string, length = 3): boolean {
    const s = str.toLowerCase();
    for (let i = 0; i <= s.length - length; i++) {
      let asc = true;
      let desc = true;
      for (let j = 0; j < length - 1; j++) {
        const curr = s.charCodeAt(i + j);
        const next = s.charCodeAt(i + j + 1);
        if (next !== curr + 1) asc = false;
        if (next !== curr - 1) desc = false;
      }
      if (asc || desc) return true;
    }
    return false;
  }

  resetPwd() {
    // this.samePassword = false;
    // this.inconsistentPwd = false;
    // if (this.password !== this.cPassword) {
    //   this.inconsistentPwd = true;
    //   return false;
    // }
    // if (this.oldPassword === this.password) {
    //   this.samePassword = true;
    //   return false;
    // }
    // if (this.isStrongPwd === false) {
    //   return false;
    // }

    if (this.pwdValidationError && this.confirmValidationError) {
      this.message.error("Please fill all the required fields to continue");
      return false;
    }

    if (this.oldPassword == this.newPassword) {
      this.message.error("Old and new password should be different!");
      return false;
    }

    this.encrypt.setPublicKey(this.publicKey);
    const newpassword: any = this.encrypt.encrypt(this.newPassword);
    const prePassword: any = this.encrypt.encrypt(this.oldPassword);

    this.authenticationService
      .resetPwd(
        UIUtil.getPrivateData(session_keys.private_key).email,
        prePassword,
        newpassword,
      )
      .subscribe(
        (response) => {
          localStorage.clear();
          this.router.navigate(["./login"]);
          this.message.success(
            "Your password has been successfully reset. Please log in to continue.",
          );
          // if (response.id) {
          //   // this.isResetPwd = false;
          //   // this.incorrectPwd = false;
          //   this.authenticationService.logout().subscribe((isLogout) => {
          //     localStorage.clear();
          //   });
          // } else {
          //   this.isResetPwd = true;
          //   this.incorrectPwd = true;
          // }
        },
        (err) => {
          this.message.error(err.Message);
        },
      );
  }

  checkStrengthPwd(value): boolean {
    return UIUtil.strongPwd(value);
  }
}
